
/* injects from baggage-loader */

'use strict';

import AccountDocumentRequestReviewController from './account.document-request-review.controller';
import AccountDocumentRequestReviewTemplate from './account.document-request-review.html';

export default class AccountDocumentRequestReviewComponent {
		constructor() {
				this.templateUrl = AccountDocumentRequestReviewTemplate;
				this.controller = AccountDocumentRequestReviewController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					documentRequest: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/document-request-review/account.document-request-review.component.js